var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rounded-2.5xl overflow-hidden"},[_c(_setup.OzBox,{class:[
      'flex flex-col',
      'h-full w-full',
      'overflow-auto',
      'py-1',
      _vm.darkMode ? 'scrollbar-thin-dark' : 'scrollbar-thin',
    ],style:(_vm.containerStyle),attrs:{"color":_setup.OzBoxColors.Primary,"dark-mode":_vm.darkMode}},[_c(_setup.OzMenuRows,{attrs:{"accessibility-role":'menu',"aria-label":_vm.label,"dark-mode":_vm.darkMode,"size-preset":_setup.OzMenuRowsSizePreset.H56px,"common-settings":{
        role: 'menuitemradio',
        iconSize: 20,
      },"focus-style":_setup.OzMenuRowsFocusStyle.Grey100,"x-last-row-divider":false,"rows":_vm.rows},on:{"select-row":_setup.onRowSelect}}),_vm._v(" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }